import { ConnectionType, CurrentUnit, LoadType, MotorDriveConnection, SpeedUnit, TorqueUnit, UnitSystem } from '../enums';
import { MesRequest } from '../models';
import { DEFAULT_LANGUAGE_VALUE } from './Language';
import { DEFAULT_STARTING_CONDITION } from './StartingCondition';
import { DEFAULT_STARTING_TYPE } from './StartingType';
import { DEFAULT_TEMPERATURE_CLASS } from './TemperatureClass';

export const INITIAL_MES_REQUEST: MesRequest = {
    commonData: {
        mlfb: '',
        options: '',
        maMn: null,
        ma: null,
        mk: null,
        mn: null,
        ms: null,
        ns: null,
        nw: null,
        nwWithTolerance: null,
        nN: null,
        nsyn: null,
        poleNumber: null,
        frequency: null,
        startingVoltage: null,
        isBreakdownToleranceOn: false,
        isLockedRotorPullupToleranceOn: false,
        isStartupNumbersChecked: true,
        startingCondition: DEFAULT_STARTING_CONDITION,
        torqueUnit: TorqueUnit.Nm,
        speedUnit: SpeedUnit.Rpm,
        currentUnit: CurrentUnit.A,
        ac: null,
        aw: null,
        startingType: DEFAULT_STARTING_TYPE,
        explosionProtection: DEFAULT_LANGUAGE_VALUE,
        isExEbIICType: false,
        temperatureClass: DEFAULT_TEMPERATURE_CLASS,
        ydSwitchPossible: false
    },
    loadData: {
        loadType: LoadType.QuadraticWithoutBreakaway,
        n0: null,
        n1: null,
        n2: null,
        n3: null,
        n4: null,
        m0: null,
        m1: null,
        m2: null,
        m3: null,
        m4: null
    },
    currentData: {
        startingCurrentRatio: null,
        ratedCurrent: null,
        noLoadCurrent: null,
        motorRatedVoltage: null
    },
    gearboxData: {
        n1: null,
        n2: null,
        motorInertia: null,
        gearboxInertia: null,
        loadInertia: null,
        motorDriveConnection: MotorDriveConnection.Direct
    },
    motorData: {
        id: null,
        mlfb: '',
        winding: DEFAULT_LANGUAGE_VALUE,
        power: null,
        tStartWarm: null,
        tStartCold: null,
        tBlockMaxWarm: null,
        tBlockMaxCold: null,
        heatingTimeT1T2: null,
        heatingTimeT3: null,
        connectionType: ConnectionType.Star,
        ratedPowerBasedOn: null,
        lineVoltage: null,
        efficiencyClass: '',
        speed: null,
        pn: null,
        frameMaterial: DEFAULT_LANGUAGE_VALUE,
        motorType: DEFAULT_LANGUAGE_VALUE,
        frameSize: ''
    },
    unitSystem: UnitSystem.SI
};
